export default __webpack_public_path__ + "static/media/cd.7a412b03.svg";